/**
 * Testfamilien (1.17): the personal link in an invitation (`/?einladung=…`) is kept on this
 * device until the family is created – signing up in between may take a while. The address bar
 * is cleaned right away, so the link does not end up in screenshots or bookmarks.
 */
const KEY = 'shh.invite';

export function captureInvite() {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('einladung');
  if (!token) return;
  try {
    localStorage.setItem(KEY, token.slice(0, 100));
  } catch {
    // private mode: the family can still be created, just not marked
  }
  url.searchParams.delete('einladung');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}

export function readInvite(): string | undefined {
  try {
    return localStorage.getItem(KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function clearInvite() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing stored
  }
}
